import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3d38e80a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3d38e80a&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d38e80a')) {
      api.createRecord('3d38e80a', component.options)
    } else {
      api.reload('3d38e80a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3d38e80a", function () {
      api.rerender('3d38e80a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/blindDataOrder/list/index.vue"
export default component.exports